import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { paymentHistoryExportColumns } from '../../config/exportColumns/paymentHistoryExportColumns'
import { appAllGetFundrasing } from '../../store/fundrasing'
import TableFilter from './tableFilter'

function PaymentHistory() {
	const dispatch = useDispatch()
	const activeFilters = {}
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Payment History</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appAllGetFundrasing({ ...params, loading: false }))}
							columns={paymentHistoryExportColumns}
							fileName="Payment History"
							sheetName="Payment History List"
							buttonText="Export Payment History"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default PaymentHistory
